import React, { useEffect, useState } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import "../../TargetReport/TableContent/index.css";
import "./operations.css";

function TableContent({ tableData }) {
  const formatter = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const dataTable = tableData?.map(function (item, index) {
    let backColor = "#EEEEEE";
    if (index % 2) {
      backColor = "white";
    }
    let indice = 0;
    return (
      <>
        <TableRow style={{ height: ".5rem" }}>
          <TableCell style={{ borderLeft: "none" }}></TableCell>
        </TableRow>
        <TableRow
          key={item.index}
          style={{
            backgroundColor: backColor,
            borderTop: "solid 1px black",
            borderBottom: item.rede.length > 1 ? "none" : "solid 1px black",
          }}>
          <TableCell
            rowSpan={item.rede.length}
            align='left'
            style={{
              borderLeft: "solid 1px black",
              borderBottom: "solid 1px black",
              width: "400px",
            }}>
            {item.analista}
          </TableCell>
          <TableCell align='left' style={{ borderLeft: "none" }}>
            {item.rede[0].rede}
          </TableCell>
          <TableCell
            align='right'
            style={{
              borderRight: "solid 1px black",
              borderLeft: "none",
              width: "100px",
            }}>
            {item.rede[0].qtdDiasOperado}
          </TableCell>
        </TableRow>
        {item.rede?.map((rede, redeId) => {
          indice++;
          if (indice > 1) {
            return (
              <TableRow
                style={{
                  backgroundColor: backColor,
                  borderBottom:
                    indice >= item.rede.length ? "solid 1px black" : "none",
                }}>
                <TableCell align='left' style={{ borderLeft: "none" }}>
                  {rede.rede}
                </TableCell>
                <TableCell
                  align='right'
                  style={{
                    borderRight: "solid 1px black",
                    borderLeft: "none",
                    width: "100px",
                  }}>
                  {rede.qtdDiasOperado}
                </TableCell>
              </TableRow>
            );
          }
        })}
      </>
    );
  });

  return (
    <>
      <div
        className='report-tables'
        style={{
          margin: "0px 10% 0px 30%",
          zIndex: "0",
          position: "relative",
          justifyContent: "space-between",
          flexWrap: "wrap",
          display: "flex",
          overflowX: "auto",
        }}>
        <Table
          style={{
            backgroundColor: "white",
            marginBottom: "20px",
            width: "70%",
            boxShadow:
              "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
          }}>
          <TableHead style={{ backgroundColor: "#232C63" }}>
            <TableRow>
              <TableCell
                style={{
                  color: "white",
                  fontWeight: "bold",
                  borderLeft: "1px solid #232c63",
                }}
                align='left'>
                Analista
              </TableCell>
              <TableCell
                style={{
                  color: "white",
                  fontWeight: "bold",
                  border: "none",
                  width: "110px",
                }}
                align='left'>
                Rede
              </TableCell>
              <TableCell
                style={{
                  color: "white",
                  fontWeight: "bold",
                  border: "none",
                  width: "100px",
                }}
                align='right'>
                Qtd dias Operado
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{dataTable}</TableBody>
        </Table>
      </div>
      <div
        style={{
          marginTop: "20px",
          zIndex: "0",
          position: "relative",
          justifyContent: "start",
        }}></div>
    </>
  );
}

export default TableContent;
